<div class="modal-header">
  <h4 class="modal-title">Blueprint Assignment Preview</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()"></button>
</div>
<div class="modal-body">
  <div class="preview-info mb-3">
    <p><strong>Project:</strong> {{ projectOid }}</p>
    <p><strong>Blueprints to assign:</strong> {{ blueprintPreviews.length }}</p>
  </div>

  <div class="blueprint-previews">
    <div *ngFor="let blueprint of blueprintPreviews; let i = index" class="blueprint-preview-item mb-3">
      <h6 class="blueprint-header">
        <span class="badge bg-primary me-2">{{ i + 1 }}</span>
        Blueprint ID: <a [href]="'/quota/capacity/' + blueprint.id + '/details'" target="_blank" class="blueprint-link">{{ blueprint.id }}</a>
      </h6>
      <div class="preview-content">
        <pre class="preview-text">{{ blueprint.previewContent }}</pre>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="onCancel()">Cancel</button>
  <button type="button" class="btn btn-primary" data-test="ConfirmAssign" (click)="onConfirm()">
    Confirm Assignment ({{ blueprintPreviews.length }} blueprint<span *ngIf="blueprintPreviews.length > 1">s</span>)
  </button>
</div>
